import { Box, Grid, Typography, makeStyles } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { ShaDowBox } from "../../../../components/boxes";

import { getData, nKilowattFormatter, currencyFormatter } from "../../../../services";
import { COLORS } from "../../../../theme/colors";
import { Icon } from "../../../../components/base";
import { NoDataCard } from "../../../../components/parts";

import checkImg from "../../../../assets/images/icons/check.svg";
import AssetsIcon from "../../../../assets/images/icons/nav/assets.svg";

import SolarIcon from "../../../../assets/images/icons/solar.svg";
import EVIcon from "../../../../assets/images/icons/ev-charge.svg";
import BatteryIcon from "../../../../assets/images/icons/battery.svg";

const useStyles = makeStyles(() => ({
  rightSide: {
    borderRight: `1px solid ${COLORS.darks[0][25]}`,
    paddingTop: 12,
  },
  assetType: {
    marginLeft: 10,
    fontWeight: "bold",
    fontSize: 18,
  },
  assetInfo: {
    fontSize: 14,
  },
  boxButton: {
    border: `1px solid ${COLORS.darks[0][25]}`,
    borderRadius: 10,
    marginTop: 8,
    marginLeft: 18,
    paddingTop: 12,
    paddingBottom: 8,
    padding: 12,
    boxShadow: `0px 12px 26px 0px ${COLORS.darks[0][6]}`,
    color: COLORS.purple,
  },
  box: {
    paddingLeft: 18,
    fontWeight: "bold",
  },
  installedAsset: {
    color: COLORS.green,
    paddingBottom: 2,
  },
  capacitity: {
    marginLeft: 18,
    marginRight: 4,
    paddingTop: 4,
  },
  unrealized: {
    color: COLORS.red,
  },
  icon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "100%",
    width: 48,
    height: 48,
    borderWidth: 1,
    borderStyle: "solid",
  },
  batteriesBorderColor: {
    borderColor: COLORS.majorelleBlue,
  },
  evBorderColor: {
    borderColor: COLORS.cian,
  },
  solarBorderColor: {
    borderColor: COLORS.mikadoYellow,
  },
  ev: {
    paddingLeft: 18,
  },
  solar: {
    paddingLeft: 18,
  },
}));

export const PowerAssets = ({ buildingId, complexId }) => {
  const classes = useStyles();
  const [assets, setPowerAssets] = useState(null);
  const [rec, setRec] = useState(null);
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);
  const { cluster, segments, selectedCountries } = useSelector((state) => state.selectCSC);

  useEffect(() => {
    if (complexId) {
      setPowerAssets(null);
      return;
    }
    const url = buildingId ? `/praas/v1/buildings/${buildingId}/power-assets/` : "/praas/v1/buildings/power-assets/";
    getData(url, (data) => {
      setPowerAssets(Object.entries(data).map(([key, value]) => ({ ...value, name: key })));
    }).catch(() => setPowerAssets(null));
  }, [cluster, segments, selectedCountries, buildingId]);

  useEffect(() => {
    if (complexId) {
      setRec(null);
      return;
    }
    const url = buildingId ? `/praas/v1/buildings/${buildingId}/power-asset-reccomendations/` : "/praas/v1/buildings/power-asset-reccomendations/";
    getData(url, setRec).catch(() => setRec(null));
  }, [cluster, segments, selectedCountries, buildingId]);

  if (!assets || !rec) return <NoDataCard title="Installed Assets" />;

  const getPowerAssetIcon = (name) => {
    switch (name) {
      case "batteries":
        return <img src={BatteryIcon} />;
      case "ev":
        return <img src={EVIcon} />;
      case "solar":
        return <img src={SolarIcon} />;
      default:
        return;
    }
  };

  const getName = (name) => {
    switch (name) {
      case "batteries":
        return "BATTERIES";
      case "ev":
        return "EV CHARGES";
      case "solar":
        return "SOLAR";
      default:
        return;
    }
  };

  return (
    <ShaDowBox fullHeight>
      <Box style={{ padding: 18 }}>
        <Box className={classes.installedAsset}>
          <Icon style={{ verticalAlign: "middle", marginRight: 2 }} src={checkImg} />
          Installed Assets
        </Box>
        <Grid container wrap="nowrap">
          {assets.map((value, key) => (
            <Grid key={key} item sm={6} className={classes.rightSide}>
              <Grid container className={`${classes[value.name]}`}>
                <div className={`${classes.icon} ${classes[value.name + "BorderColor"]}`}>
                  {getPowerAssetIcon(value.name)}
                </div>
                <Grid className={classes.assetType}>
                  {value.count || 0} {getName(value.name)}
                  <Typography className={classes.assetInfo}>
                    Total Capacity {nKilowattFormatter(value.capacity)}
                  </Typography>
                  <Typography className={classes.assetInfo}>
                    Acc Revenues {currencyFormatter(value.acc_revenues, currencySymbol)}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          ))}
          <Grid item sm={8}>
            <Box className={classes.box}>Reccomendations</Box>
            <Box className={classes.boxButton}>
              <Icon
                style={{
                  verticalAlign: "middle",
                  marginRight: 4,
                  paddingRight: 10,
                  borderRight: `1px solid ${COLORS.darks[0][25]}`,
                }}
                src={AssetsIcon}
              />
              APPROVE NEW POWER ASSETS ({rec.new})
            </Box>
            <Typography className={classes.capacitity}>
              Capacitity {nKilowattFormatter(rec.capacitity)};{" "}
              <span className={classes.unrealized}>Unrealized Rev: {rec.unrealized} K/mo</span>
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </ShaDowBox>
  );
};
